import { render } from "./Turntable.vue?vue&type=template&id=537c9abc&scoped=true"
import script from "./Turntable.vue?vue&type=script&lang=js"
export * from "./Turntable.vue?vue&type=script&lang=js"

import "./Turntable.vue?vue&type=style&index=0&id=537c9abc&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537c9abc"]])

export default __exports__